export const legalContent = {
  privacy: {
    title: '隐私政策',
    intro: 'Nova·云枢非常重视用户隐私保护。本政策说明我们如何收集、使用、存储和保护您的个人信息。',
    sections: [
      ['信息收集', '使用平台服务时，可能收集设备信息、浏览记录和操作日志；注册时收集提供服务所必需的账户信息。'],
      ['信息使用', '信息仅用于提供和优化服务、保障交易安全、内容推荐及防止违规行为。'],
      ['信息保护', '采用数据加密、访问控制和安全审计等措施保护个人信息。'],
      ['您的权利', '您可以依法访问、更正、删除个人信息，以及撤回授权。'],
    ],
  },
  agreement: {
    title: '用户协议',
    intro: '使用 Nova·云枢服务前，请仔细阅读以下协议条款。',
    sections: [
      ['服务内容', '平台提供 AIGC 内容展示、创作者服务、品牌任务对接和课程培训等功能。'],
      ['用户资格', '创作者需满足年龄和资质要求，并通过平台审核后发布作品或接单。'],
      ['行为规范', '不得发布违法、侵权或有害内容，不得进行虚假交易或干扰平台运营。'],
      ['知识产权', '作品版权归权利人所有，品牌任务成果按任务约定执行。'],
    ],
  },
  safety: {
    title: '内容安全规范',
    intro: '为营造健康、安全的内容生态，所有用户均需遵守本规范。',
    sections: [
      ['禁止内容', '禁止发布违法、侵权、暴力恐怖、色情低俗、虚假和仇恨歧视等内容。'],
      ['AIGC 标注', '使用 AI 工具生成的内容应按适用规则进行清晰标注。'],
      ['内容审核', '平台对发布内容进行审核，未通过内容可在修改后重新提交。'],
      ['违规处理', '平台将根据违规程度采取提醒、限流、暂停服务或封禁等措施。'],
    ],
  },
} as const
